import { render, staticRenderFns } from "./data52.vue?vue&type=template&id=1a2d6bfb&scoped=true&"
import script from "./data52.vue?vue&type=script&lang=js&"
export * from "./data52.vue?vue&type=script&lang=js&"
import style1 from "./data52.vue?vue&type=style&index=1&id=1a2d6bfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d6bfb",
  null
  
)

export default component.exports